import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

const AppFallbackUI = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        pt: 4,
      }}
    >
      <Paper sx={{ p: 4 }}>
        <Typography sx={{ mb: 2 }} variant="h4">
          <FormattedMessage id="NotFound-AppFallbackUI-title" defaultMessage="The page could not be found." />
        </Typography>
        <Typography sx={{ mb: 2 }} variant="subtitle1">
          <FormattedMessage
            id="NotFound-AppFallbackUI-content"
            defaultMessage="You have navigated to a path that doesn't exist. Please check the URL or use the menu to navigate to a different page."
          />
        </Typography>
      </Paper>
    </Box>
  );
};

export default AppFallbackUI;
